import type { VariableType } from "./types";
import StringVariable from "./definitions/StringVariable";
import NumberVariable from "./definitions/NumberVariable";
import BooleanVariable from "./definitions/BooleanVariable";
import DateVariable from "./definitions/DateVariable";
import DateTimeVariable from "./definitions/DateTimeVariable";

const toVariableDefinition = (type: VariableType) => {
  switch (type) {
    case "string":
      return StringVariable;
    case "number":
      return NumberVariable;
    case "boolean":
      return BooleanVariable;
    case "date":
      return DateVariable;
    case "datetime":
      return DateTimeVariable;
  }
};

export default toVariableDefinition;
